const DEFAULT_PAGE_TITLE = 'Orange zákaznícka zóna';
/**
 * @property {string} path
 * @property {string} title - title and og title of the page
 * @property {?string} description - og description of the page
 * @property {function({
 *   pathParams: Object,
 *   query: URLSearchParams,
 *   anchor: string
 * }): TemplateResult} template
 * @property {?string} heading - text of the heading section if page should have any
 * @property {?(Breadcrumb[])} breadcrumbs
 * @property {boolean} shouldRenderSnPicker - whether page should have SN picker section rendered
 * @property {?string} snPickerOnDemandTopic - messageBus topic that listens on info whether to additionally render SN picker on page. `null` means it's enabled by default
 * @property {?string} activeMenuItem - which menu item should be in focus, defined by its path
 * @property {?string} type - mHub page type attribute
 * @property {?string} section - mHub page section attribute
 * @property {boolean} hasCustomPageViewHandling - whether mHub pageView push event is triggered automatically through Router.js or widget handles it on its own through infraProxy
 * @property {boolean} isWip - whether page is still work in progress and should redirect to 404 for environments without WIP features
 * @property {boolean} skipSnQueryVerification - unless set to true, the number in the `sn` query param will be verified to be one of available sub-SNs and removed otherwise
 */
export class Route {
  /**
   * @param {string} path
   * @param {string} title - title and og title of the page
   * @param {?string} description - og description of the page
   * @param {function({
   *   pathParams: Object,
   *   query: URLSearchParams,
   *   anchor: string
   * }): TemplateResult} template
   * @param {?string} heading - text of the heading section if page should have any
   * @param {?(Breadcrumb[])} breadcrumbs
   * @param {boolean} shouldRenderSnPicker - whether page should have SN picker section rendered
   * @param {?string} snPickerOnDemandTopic - messageBus topic that listens on info whether to additionally render SN picker on page. `null` means it's enabled by default
   * @param {?string} activeMenuItem - which menu item should be in focus, defined by its path
   * @param {?string} type - mHub page type attribute
   * @param {?string} section - mHub page section attribute
   * @param {boolean} hasCustomPageViewHandling - whether mHub pageView push event is triggered automatically through index.js or widget handles it on its own through infraProxy
   * @param {boolean} isWip - whether page is still work in progress and should redirect to 404 for environments without WIP features
   * @param {boolean} skipSnQueryVerification - unless set to true, the number in the `sn` query param will be verified to be one of available sub-SNs and removed otherwise
   */
  constructor({
    path = '',
    title = DEFAULT_PAGE_TITLE,
    description = '',
    template = null,
    heading = null,
    breadcrumbs = [],
    shouldRenderSnPicker = false,
    snPickerOnDemandTopic = null,
    activeMenuItem = null,
    type = null,
    section = null,
    hasCustomPageViewHandling = false,
    isWip = false,
    skipSnQueryVerification = false,
  }) {
    this.path = path;
    this.title = title;
    this.description = description;
    this.template = template;
    this.heading = heading;
    this.breadcrumbs = breadcrumbs;
    this.shouldRenderSnPicker = shouldRenderSnPicker;
    this.snPickerOnDemandTopic = snPickerOnDemandTopic;
    this.activeMenuItem = activeMenuItem;
    this.type = type;
    this.section = section;
    this.hasCustomPageViewHandling = hasCustomPageViewHandling;
    this.isWip = isWip;
    this.skipSnQueryVerification = skipSnQueryVerification;
  }
}
